export const getActiveProviderCode = async (): Promise<string> => {
  // TODO: read from Sanity `inventoryProvider` document when available
  // Fallback to env for now
  const code = (typeof process !== 'undefined' && process.env?.INVENTORY_PROVIDER) || 'zoho'
  return code
}

